import React from 'react';

import { useIntl } from 'react-intl-next';

import { ErrorMessage, Field } from '@atlaskit/form';
import TextField from '@atlaskit/textfield';

import commonMessages from '../../../messages';
import { FieldResetter } from '../../styled';

import messages from './messages';
import { type NameInputsProps } from './types';

export const NameInputs: React.FC<NameInputsProps> = ({
	name,
	description,
	isCloning,
	escalationNames,
}) => {
	const { formatMessage } = useIntl();

	return (
		<>
			<FieldResetter>
				<Field
					label={formatMessage(messages.name)}
					name="name"
					defaultValue={isCloning ? '' : name || ''}
					isRequired
					aria-required={true}
					validate={(val) => {
						if (!val) {
							return formatMessage(commonMessages.fieldRequired);
						}

						if (escalationNames?.includes(val) && val !== name) {
							return formatMessage(commonMessages.alreadyExist, { name: val });
						}
					}}
				>
					{({ fieldProps: { isRequired, ...fieldProps }, error }) => (
						<>
							<TextField
								autoComplete="off"
								placeholder={formatMessage(messages.namePlaceholder)}
								{...fieldProps}
							/>
							{error && <ErrorMessage>{error}</ErrorMessage>}
						</>
					)}
				</Field>
			</FieldResetter>
			<FieldResetter>
				<Field
					label={formatMessage(messages.description)}
					name="description"
					defaultValue={description || ''}
				>
					{({ fieldProps }) => (
						<TextField
							autoComplete="off"
							placeholder={formatMessage(messages.descriptionPlaceholder)}
							{...fieldProps}
						/>
					)}
				</Field>
			</FieldResetter>
		</>
	);
};
